// list of type filters 
export const type = [
  {
    cat: 'Type',
    key: 'Breakfast',
    display: 'Breakfast'
  },
  {
    cat: 'Type',
    key: 'Lunch',
    display: 'Lunch'
  },
  {
    cat: 'Type',
    key: 'Dinner',
    display: 'Dinner'
  },
  {
    cat: 'Type',
    key: 'Dessert',
    display: 'Dessert'
  },
  {
    cat: 'Type',
    key: 'Appetizer-&-Snack',
    display: 'Appetizer & Snack'
  }
];